const ImageSizes = {
    xsmall: { imageHeight: 32, imageWidth: 32 },
    small: { imageHeight: 48, imageWidth: 48 },
    medium: { imageHeight: 64, imageWidth: 64 },
    large: { imageHeight: 100, imageWidth: 100 },
    xlarge: { imageHeight: 120, imageWidth: 120 },
    flex: { imageHeight: 0, imageWidth: 0 },
};
export const getImageSizeStyle = (size = 'medium') => {
    return ImageSizes[size];
};
export const getContainerStyle = (activeSize, icon, imageHeight, imageWidth, imageFit) => {
    return {
        position: 'relative',
        height: 'fit-content',
        width: activeSize === 'flex' ? '100%' : 'fit-content',
        maxWidth: activeSize === 'flex' ? '9.6rem' : 'initial', // Max width defined by component styles.
        aspectRatio: '1 / 1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: activeSize === 'flex' ? '100%' : imageHeight,
            height: activeSize === 'flex' ? '100%' : imageWidth,
            aspectRatio: '1 / 1',
            borderRadius: imageFit === 'cover' ? '0.2rem' : 'initial',
        },
        '& svg': {
            circle: {
                display: activeSize === 'xsmall' || activeSize === 'small' || icon === 'actionIcon'
                    ? 'none'
                    : 'initial',
            },
        },
        '& label': {
            overflow: 'hidden',
            width: activeSize === 'flex' ? '100%' : 'initial',
            height: activeSize === 'flex' ? '100%' : 'initial',
        },
    };
};
export const getIconContainerStyle = (activeSize) => {
    return {
        position: 'absolute',
        width: '100%',
        height: '100%',
        display: activeSize !== 'xsmall' ? 'flex' : 'none',
        justifyContent: 'center',
        '& svg': {
            width: '50%',
            height: '50%',
            alignSelf: 'center',
        },
    };
};
export const getLabelContainerStyle = (activeSize) => {
    return {
        display: activeSize === 'xlarge' ? 'initial' : 'none',
        '& svg': {
            display: 'initial',
        },
    };
};
//# sourceMappingURL=SelectableImage.styles.js.map